import { useLocation, useNavigate } from "react-router-dom";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// import { ExpandMoreIcon, ChevronRightIcon } from "@mui/icons-material";
import "./Sidebar.css";
import { useState, useEffect } from "react";
import {
  Badge,
  Button,
  Modal,
  Table,
  Pagination,
  DatePicker,
  Tooltip,
} from "antd";
import { notify_error, notify_success } from "./Notify";
import cookie from "js-cookie";
import UserAPI from "../utils/api/UserAPI";
import FilterOnlineEnquiry from "./FilterOnlineEnquiry";

const FilterSideBar = (props) => {
  const [profileimage, setImage] = useState(cookie.get("image"));
  const [open, setOpen] = useState(false);
  let fname = cookie.get("firstname");
  let lname = cookie.get("lastname");
  let _id = cookie.get("user");
  let role = cookie.get("role");
  const Admin = role == "super_admin";
  const Admission = role == "super_admin" || role == "admission";
  const Reception = role == "super_admin" || role == "reception" ||role=="counsellor";
  const Event = role == "super_admin" || role == "event";

  const navigate = useNavigate();
  const [enquiry, setEnquiry] = useState({
    firstname: "",
    lastname: "",
    file: null,
    _id: _id,
  });

  const getProfileDetails = async () => {
    const user = await UserAPI.getProfileDetails();
    const data = await user.json();
    cookie.remove("image");
    cookie.remove("lastname");

    cookie.remove("firstname");
    cookie.remove("name");

    cookie.set("image", data.data.image);
    cookie.set("name", `${data.data?.firstname} ${data.data?.lastname}`);
    cookie.set("firstname", data.data.firstname);
    cookie.set("lastname", data.data.lastname);
  };

  useEffect(() => {
    setImage(cookie.get("image"));
  }, [profileimage, cookie.get("image")]);

  const handleOk = async () => {
    if (enquiry.file == null || !enquiry.file) {
      notify_error("please Select a File");
    } else {
      const fd = await new FormData();
      fd.append("firstname", enquiry?.firstname || fname);

      fd.append("lastname", enquiry?.lastname || lname);
      fd.append("_id", enquiry._id);

      fd.append("file", enquiry.file);

      UserAPI.updateProfileDetails(fd)
        .then((response) => response.json())
        .then((data) => {
          if (data.status == true) {
            notify_success("Profile Successfully Updated");
            handleCancel();
            setEnquiry({
              firstname: enquiry?.firstname || fname,
              lastname: enquiry?.lastname || lname,
              file: null,
              _id: _id,
            });
            getProfileDetails();
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          } else {
            notify_error(data.message);
          }
        })
        .catch((err) => {
          notify_error(err.message);
        });
    }
  };

  const handleCancel = () => {
    setOpen(false);
  };


  const handleEdit=(e)=>{
      e.preventDefault();
      setOpen((prev)=>!prev)
  }


  const handleOnChange = (event) => {
    const { name, value, type } = event.target;
    const newValue = type === "file" ? event.target.files[0] : value;
    setEnquiry((prevState) => ({
      ...prevState,
      [name]: newValue,
    }));
    // console.log(enquiry);
    const selectedFile = event.target.files[0];
    if (
      selectedFile &&
      (selectedFile.type === "image/jpeg" || selectedFile.type === "image/png")
    ) {
    } else {
      alert("Please select a JPG/JPEG/PNG file.");
    }
  };
  const location = useLocation();
  return (
    <nav
      className="sidebar sidebar-offcanvas "
      id="sidebar"
    //   style={{ marginTop: "70px"}}
    >
        <FilterOnlineEnquiry/>
      
    </nav>
  );
};

export default FilterSideBar;
